import axios from "./axios";
import { buildResponseArrayGetInterceptor, buildSearchURL } from "@/utils";

const baseUrl = "/api/v3/virtual-ads";

export default {
  getVirtualAds(params) {
    return axios
      .get(`${baseUrl}${buildSearchURL(params)}`)
      .then((response) => buildResponseArrayGetInterceptor(response, params));
  },
  createVirtualAd(data) {
    return axios.post(`${baseUrl}`, data);
  },
  deleteVirtualAd(id) {
    return axios.delete(`${baseUrl}/${id}`);
  },
  updateVirtualAd(id, data) {
    return axios.patch(`${baseUrl}/${id}`, data);
  },
};
